import { BaseContainerModel } from '../../../base-container.model';
import { bl_del_trip_hdr_RowClass, bl_del_trip_ext_RowClass, bl_del_driver_vehicle_link_RowClass, bl_del_region_hdr_RowClass, bl_del_driver_hdr_RowClass, bl_del_vehicle_hdr_RowClass } from '../../../../dbschema';

export class TripContainerModel extends BaseContainerModel {
    bl_del_trip_hdr: bl_del_trip_hdr_RowClass = new bl_del_trip_hdr_RowClass();
    bl_del_trip_ext: bl_del_trip_ext_RowClass[] = [];
    bl_del_driver_vehicle_link: bl_del_driver_vehicle_link_RowClass = new bl_del_driver_vehicle_link_RowClass();
    bl_del_region_hdr: bl_del_region_hdr_RowClass = new bl_del_region_hdr_RowClass();
    bl_del_driver_hdr: bl_del_driver_hdr_RowClass = new bl_del_driver_hdr_RowClass();
    bl_del_vehicle_hdr: bl_del_vehicle_hdr_RowClass = new bl_del_vehicle_hdr_RowClass();
}